import { TagTitleSection } from "../elements/TagTitleSection"
import "../styles/sections/ourtecnology.styles.css"
import img from "../assets/img2.webp"
import { FaCheckCircle } from "react-icons/fa"

export const OurTecnology = () => {
    return (
        <section id="our-tecnology" className="our-tecnology-section">
            <TagTitleSection title="Nosso Diferencial" />
            <div className="content-tecnology">
                <div className="tec-img-box">
                    <img src={img} alt="Imagem sobre tecnologia" width={700} height={500} />
                </div>
                <div className="tec-content-box">
                    <div className="tec-content">
                        <span>
                            <FaCheckCircle />
                        </span>
                        <div className="tec-content-texts">
                            <p className="tec-content-texts-title">Tecnologia em concreto</p>
                            <p className="tec-content-texts-descrip">Nossas inovações proporcionam maior eficiência, durabilidade e flexibilidade de design, contribuindo para edificações mais seguras e econômicas.</p>
                        </div>
                    </div>
                    <div className="tec-content">
                        <span>
                            <FaCheckCircle />
                        </span>
                        <div className="tec-content-texts">
                            <p className="tec-content-texts-title">Projetos técnicos</p>
                            <p className="tec-content-texts-descrip">Os projetos da Premold está na inspeção realizada por profissionais altamente capacitados. Cada etapa do processo de construção de galpões pré-moldados é cuidadosamente supervisionada por especialistas, garantindo a qualidade e segurança da obra.</p>
                        </div>
                    </div>
                    <div className="tec-content">
                        <span>
                            <FaCheckCircle />
                        </span>
                        <div className="tec-content-texts">
                            <p className="tec-content-texts-title">Implementação</p>
                            <p className="tec-content-texts-descrip">Um diferencial significativo da Premold é o prazo de implementação ágil e eficiente. Com métodos de construção inovadores e uma equipe altamente capacitada, a empresa é capaz de entregar os projetos de galpões pré-moldados dentro de prazos rigorosos, sem comprometer a qualidade.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}